module.exports = __webpack_public_path__ + "static/media/supplements.0adae450.png";